import React, { useState, useEffect } from 'react'

import Button from '../button/button'
import { normalizeTwoWords, formatImageAlt } from "../../../shared/utils/stringUtilities";

import './cardPodcast.scss'

interface CardPodcastInter {
  podcast: any,
  breadCrumbs: any
}

const CardPodcast = (props: CardPodcastInter) => {
  const { podcast, breadCrumbs } = props;

  const [info, setInfo] = useState<any>({});

  useEffect(() => {
    handleInfo()
  }, [])

  const handleInfo = () => {
    const mmsId = podcast.botonCompartir;
    const pid = podcast.tituloBoton;
    const url = `${process.env.CONTENTLOAN_API_URL}/contentloan/api/v1//detail/collection-podcast?mmsId=${mmsId}&pid=${pid}`

    fetch(url)
      .then((data) => data.json())
      .then((data) => {
        setInfo(data.data)
      })
  }

  const getCurrentPage = () => {
    const arr = breadCrumbs.split("/");
    return arr[arr.length - 1].trim();
  }

  return (
    <div className='a-card-podcast'>
      <div className='a-card-podcast__img'>
        <div className='a-card-podcast__img-container'>
          <img 
            src={info.cover} 
            alt={info.image.title ? 
              formatImageAlt(info.image.title) : `Portada ${info.titulo}`
            }
          />
          <div className='icon-microphone a-card-podcast__img-container__icon'></div>
          <div className='a-card-podcast__img-container__shadow'></div>
        </div>

        <div className='a-card-podcast__img-episodes'>
          <span>{info.numberOfEpisodes}</span>
        </div>

        <div className='a-card-podcast__img-button show-mobile'>
          <Button
            type='link'
            classname='a-card-podcast__img-button__btn'
            text='ESCUCHAR AHORA'
            isDisabled={false}
            href={info.links ? info.links[0].link : ''}
          />
        </div>

        <div className='a-card-podcast__img-title show-mobile'>
          <span className='a-card-podcast__img-title__title'>{info.title}</span>
        </div>

      </div>

      <div className='a-card-podcast__description'>
        <h1 className='a-card-podcast__description-title'>{info.title}</h1>
        <span className='a-card-podcast__description-subtitle'>{info.author}</span>
        <p className='a-card-podcast__description-paragraph'>{info.description}</p>

        <Button
          type='link'
          classname='a-card-podcast__description-btn'
          text='ESCUCHAR AHORA'
          isDisabled={false}
          href={info.links ? info.links[0].link : ''}
          gtmMark={`gtm${normalizeTwoWords(getCurrentPage())}Banner${normalizeTwoWords(info.title)}`}
        />
      </div>
    </div>
  )
}

export default CardPodcast;
